import AddressVerification from './AddressVerification.component';

export default AddressVerification;
